var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"panel-change-password fill-height",attrs:{"fluid":""}},[_c('div',{staticClass:"pa-2 fill-height fill-width"},[_c('ChangePassword')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }